module.exports = __webpack_public_path__ + "chroy.6fba994bef8361101ebf.ttf";


//////////////////
// WEBPACK FOOTER
// /mnt/c/Dev/CoolDevs/modos/app/src/assets/fonts/chroy.ttf
// module id = ../../../../../src/assets/fonts/chroy.ttf
// module chunks = styles